module.exports = __webpack_public_path__ + "img/logo_supra.6d1e2141.png";